module.exports = __webpack_public_path__ + "img/gilletPub.efd5caf0.png";